/**
 * Wire-protocol source strings that indicate consulting-style product grids.
 *
 * Kept in `common/` because both the protocol adapter and chat-specific
 * renderers need to agree on which sources activate style-variation grids.
 */

/** Whether a wire-protocol source string is a consulting source. */
export function isConsultingSource(source: string | undefined): boolean {
  return source === 'beauty_consulting' || source === 'account_expert';
}
